/* C Steps Gold (14 October 2026). 1) Scroll linked gold: each card's --p runs 0 to 1 as its top moves from 90% to 45% of the
   screen, both ways; one rAF per scroll, only while on screen (r211: reads then writes, write on change; reduced motion keeps
   full gold). 2) Photo swap, once: with data-swap="2" the 2 frames trade places after 2 s at 60% on screen (paused off screen
   or in a hidden tab), a 1.8 s CSS move. Never under reduced motion. Set up once per [data-gsx] and on shopify:section:load. */
(function(){
  'use strict';
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(x){return x<0?0:x>1?1:x}
  function init(sec){
    if(sec._gsx)return;sec._gsx=1;
    var cards=[].slice.call(sec.querySelectorAll('.gsx__card')),raf=0,seen=false,timer=0;
    var every=(+sec.getAttribute('data-swap')||0)*1000;
    var tops=[],pv=[];
    function tick(){raf=0;if(!seen||RM)return;var vh=window.innerHeight,i,v;
      for(i=0;i<cards.length;i++)tops[i]=cards[i].getBoundingClientRect().top;
      for(i=0;i<cards.length;i++){v=clamp((vh*.9-tops[i])/(vh*.45)).toFixed(3);if(v!==pv[i]){pv[i]=v;cards[i].style.setProperty('--p',v)}}}
    function req(){if(seen&&!raf)raf=requestAnimationFrame(tick)}
    var ph=sec.querySelector('.gsx__ph'),frames=ph?[].slice.call(ph.querySelectorAll('.gsx__f')):[],left=every,vis=false,t0=0,done=!every||frames.length<2;
    function swap(){done=true;timer=0;frames.forEach(function(f){f.classList.toggle('p-big');f.classList.toggle('p-small')});sec.classList.add('is-sw')}
    function arm(){
      if(done||RM)return;
      if(timer){clearTimeout(timer);timer=0;left-=Date.now()-t0}
      if(vis&&!document.hidden){t0=Date.now();timer=setTimeout(swap,Math.max(0,left))}
    }
    if(RM){cards.forEach(function(c){c.style.setProperty('--p',1)})}
    else{window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req)}
    if('IntersectionObserver' in window){new IntersectionObserver(function(E){seen=E[E.length-1].isIntersecting;if(seen)req()},{rootMargin:'100px 0px'}).observe(sec);
      if(ph&&!done)new IntersectionObserver(function(E){vis=E[E.length-1].isIntersecting;arm()},{threshold:.6}).observe(ph)}
    else{seen=true;vis=true;tick();arm()}
    document.addEventListener('visibilitychange',arm);
  }
  function all(root){(root||document).querySelectorAll('[data-gsx]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all()});else all();
  document.addEventListener('shopify:section:load',function(e){all(e.target)});
})();
